import { render, staticRenderFns } from "./LaboratoryReport.vue?vue&type=template&id=9eec21d6&scoped=true"
import script from "./LaboratoryReport.vue?vue&type=script&lang=js"
export * from "./LaboratoryReport.vue?vue&type=script&lang=js"
import style0 from "./LaboratoryReport.vue?vue&type=style&index=0&id=9eec21d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eec21d6",
  null
  
)

export default component.exports